/**
 * Global cookie definitions for the application.
 * All shared cookies should be defined here to ensure consistency across SSR and client.
 */

/**
 * Cookie to track if user has selected B2B or B2C
 *
 * @returns Ref<string | null>
 * - Value is 'true' when user has made a selection
 * - Value is null/undefined when no selection has been made
 */
export const useB2bB2cUserSelectedCookie = () => {
  return useCookie<string | null>('b2b-b2c-userSelected', {
    maxAge: 3600 * 24 * 182, // 6 months
    path: '/',
  });
};

/**
 * Cookie storing the selected customer type
 *
 * @returns Ref<'b2b' | 'b2c' | null>
 * - Value is 'b2b' for business customers
 * - Value is 'b2c' for consumer customers
 * - Value is null/undefined when not set
 */
export const useCustomerTypeCookie = () => {
  return useCookie<'b2b' | 'b2c' | null>('customerType', {
    maxAge: 3600 * 24 * 182, // 6 months
    path: '/',
  });
};
